export default "__VITE_ASSET__3f01fa78__"